export interface IAccountAPI {
  account_id: number;
  name: string;
  logo_url: string;
}

export default class Account {
  id: number;

  name: string;

  logoUrl: string;

  constructor(id = -1, name: string, logoUrl: string) {
    this.id = id;
    this.name = name;
    this.logoUrl = logoUrl;
  }

  get idAndName(): string {
    return `${this.id} - ${this.name}`;
  }

  static fromApi(apiObject: IAccountAPI): Account {
    return new Account(apiObject.account_id, apiObject.name, apiObject.logo_url);
  }

  toApi(): IAccountAPI {
    return {
      account_id: this.id ?? undefined,
      name: this.name,
      logo_url: this.logoUrl,
    };
  }
}
